import { ESG, Agri, Infra } from "@/components/Marketing";

export default function Impact() {
  return (
    <>
      <ESG />
      <Agri />
      <Infra />
    </>
  );
}
